import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Input from '../Input';

export const INPUT_BOOLEAN_CHECKBOX = 'checkbox';
export const INPUT_BOOLEAN_RADIO = 'radio';
export const INPUT_BOOLEAN_VARIANTS = {
  regular: 'regular',
  wide: 'wide',
  fixed: 'fixed',
  flexible: 'flexible'
};

export const inputBooleanTypes = [INPUT_BOOLEAN_CHECKBOX, INPUT_BOOLEAN_RADIO];

const InputBooleanBase = ({ className, type, ...props }) => {
  if (!inputBooleanTypes.includes(type)) {
    throw new TypeError(
      `InputBooleanBase must be type of ${inputBooleanTypes}`
    );
  }

  return (
    <Input
      className={classnames('input__button', className)}
      disableControlClass
      type={type}
      {...props}
    />
  );
};

InputBooleanBase.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['radio', 'checkbox']).isRequired
};

export default InputBooleanBase;
